export default {
  title: 'Profil',
  type: 'object',
  properties: {
    email: {
      title: 'schema.profile.email',
      type: 'string',
      format: 'email',
      fieldRequired: true
    },
    firstName: {
      title: 'schema.profile.firstName',
      type: 'string',
      fieldRequired: true
    },
    lastName: {
      title: 'schema.profile.lastName',
      type: 'string',
      fieldRequired: true
    },
    phoneNumber: {
      title: 'schema.profile.phoneNumber',
      type: 'string',
      fieldRequired: false
    },
    birthDate: {
      title: 'schema.profile.birthDate',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    jobHistory: {
      title: 'schema.profile.jobHistory',
      type: 'string',
      fieldRequired: false
    },
    achievements: {
      title: 'schema.profile.achievements',
      type: 'string',
      fieldRequired: false
    },
    education: {
      title: 'schema.profile.education',
      type: 'string',
      fieldRequired: false
    }
  }
};
